<template>
  <div>
    <b-navbar
      toggleable="md"
      class="bottom-border"
      type="light"
      variant="light"
    >
      <!-- Right aligned nav items -->
      <b-nav class="ml-auto my-1">
        <b-button variant="primary" @click="showSenderNameModal = true"
          ><i class="fa fa-plus icons d-block">
            Register Sender Name</i
          ></b-button
        >
      </b-nav>
    </b-navbar>
    <div v-for="senderName in senderNames" :key="senderName.index">
      <div class="card m-3">
        <h5
          class="card-header card-title  "
          style="display: flex; justify-content: space-between;  word-break: break-word"
        >
          {{ senderName.sender }}
          <h4
            :class="dynamicClassList(senderName)"
            style="display:flex; align-self: center; margin: 0 0.5rem 0; padding: 0.45rem"
          >
            {{ senderName.status }}
          </h4>
        </h5>

        <div
          class="card-body"
          style="display: flex; justify-content: space-between;  word-break: break-word"
        >
          <p class="card-text">
            {{ senderName.message }}
          </p>
          <h4 style="display:flex; align-self: center; margin: 0 0.5rem 0;  ">
            {{ formattedDate(senderName.created_at) }}
          </h4>
        </div>
      </div>
    </div>
    <b-modal
      title="Request Sender name registration"
      hide-footer
      v-model="showSenderNameModal"
    >
      <SenderRegistration @isVisible="changeModalVisibility" />
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SenderRegistration from '@/components/messages/SenderRegistration';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

export default {
  name: 'SenderNames',
  components: { SenderRegistration },
  data() {
    return {
      showSenderNameModal: false,
    };
  },
  computed: {
    ...mapGetters('message', ['senderNames']),
  },
  created() {
    this.fetchSenderNames();
  },

  methods: {
    ...mapActions('message', ['fetchSenderNames']),
    changeModalVisibility(modalState) {
      this.showSenderNameModal = modalState;
    },
    dynamicClassList(senderName) {
      if (senderName.status === 'Declined') return 'badge bg-danger';

      if (senderName.status === 'Approved') return 'badge bg-success';

      return 'badge bg-secondary';
    },

    formattedDate(date) {
      const dayJs = dayjs.extend(advancedFormat);

      return dayJs(date).format('Do MMM YYYY');
    },
  },
};
</script>
